import React, { useState } from "react";
import { createAlert, getAllAlert } from "../../api/endpoints/alert.js";
import { authSelector } from "../../store/selectors/index";
import { useSelector } from "react-redux";
import { Modal, message, Select } from "antd";
import OpeningSideBar from "../openingSideBar/openingSIdeBar.js";
import { AiFillSave } from "react-icons/ai";
import { LuView } from "react-icons/lu";
import { AiFillFileAdd } from "react-icons/ai";
import { BiExit } from "react-icons/bi";
import Example from "./calling.js";
const { Option } = Select;

const Alert = () => {
  const { user, access_token } = useSelector(authSelector);
  const [itemsQueue, setItemsQueue] = useState([]);

  const [fieldsShow, setFieldsShow] = useState(false);
  const [type, setType] = useState("ADD");
  const [state, setState] = useState({
    id: "",
    alertDate: "",
    description: "",
    amount: "",
    closed: "",
  });

  const clearState = () => {
    setState({
      alertDate: "",
      nozelOrder: "",
      closed: "",
      tanks: state.tanks,
      nozels: state.nozels,
      description: "",
    });
    setItemsQueue([])
  };

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };
  const addNozel = async () => {
    setType("SAVE");
    setFieldsShow(true);
  };
  const saveNozel = async (e) => {
    const payload = {
      enteredOn: state.alertDate,
      description: state.description,
      amount: Number(state.amount),
      closed: Number(state.closed),
      siteId: Number(user.siteId),
    };

    const results = await createAlert(payload, access_token);
    if (results.success) {
      message.success(results.message || "Successfully entered!");
      clearState();
      setFieldsShow(false);
      setType("ADD");
    } else {
      message.error(results.message);
    }
  };

  const editHandler = async (e) => {
    const results = await getAllAlert(access_token);
    if (results.data.length === 0) {
      message.error("No Record Found in this date");
    }
    if (results.success) {
      const payload = results.data.reduce((acc, curr) => {
        return [
          ...acc,
          {
            id: curr.id,
            enteredOn: curr.enteredOn,
            amount: curr.amount,
            description: curr.description,
          },
        ];
      }, []);
      setItemsQueue(payload);
    } else {
      message.error(results.message);
    }
  };

  const clearStates = () => {
    clearState();
    setFieldsShow(false);
    setType("ADD");
  };
  return (
    <>
     {itemsQueue.length > 0 ? (
        <>
          <div style={{ backgroundColor: "" }}>
            {itemsQueue.length > 0 && (
              <Example
                item={itemsQueue}
               
              />
            )}
          </div>
          <div className="pb-3 flex justify-center">
            <button
              className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
              onClick={clearState}
            >
              Exit
            </button>
          </div>
        </>
     ):(
   <>
      <div className="flex  bg-black main">
        <OpeningSideBar />
        <div className="h-full  flex flex-col content-center  w-full">
          <div className="flex justify-center">
            <div className="meterTableMain flex flex-col justify-items-center justify-center w-1/2 ml-10 mt-5 mr-10">
              <div className="bg-blue-500 headingBox flex justify-center">
                <h1 className=" text-white">Alert</h1>
                {/* {contextHolder} */}
              </div>
              <div className="flex flex-col p-2 content-center items-center justify-items-center justify-evenly">
                {fieldsShow && (
                  <div>
                    <div className="flex justify-between">
                      <label className="text-white" for="fname">
                        Date:
                      </label>
                      <input
                        type="date"
                        name="alertDate"
                        value={state.alertDate}
                        onChange={onChangeText}
                        className="bg-black text-slate-400 inpTxt  h-9 ml-3 mb-3"
                      />
                    </div>
                    <div className="flex justify-between mb-3">
                      <label className="text-white" for="fname">
                        Description:
                      </label>
                      <input
                        type="text"
                        name="description"
                        value={state.description}
                        onChange={onChangeText}
                        className="bg-black text-slate-400 inpTxt h-9 ml-3 mb-3"
                      />
                    </div>
                    <div className="flex justify-between">
                      <label className="text-white" for="fname">
                        Amount
                      </label>
                      <input
                        type="number"
                        name="amount"
                        value={state.amount}
                        onChange={onChangeText}
                        className="bg-black text-slate-400inpTxt  h-8 ml-3 mb-3"
                      />
                    </div>
                  </div>
                )}

                <div className="flex justify-center">
                  {type === "ADD" && (
                    <button
                      onClick={addNozel}
                      className="bg-blue-500 hover:bg-blue-700 flex  text-white mt-3 py-1 px-4 rounded"
                    >
                      <AiFillFileAdd className="mr-2 mt-1" />

                      <span>Add</span>
                    </button>
                  )}

                  {type === "SAVE" && (
                    <button
                      onClick={saveNozel}
                      className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 py-1 px-4 rounded"
                    >
                      <AiFillSave className="mt-1 mr-2 " />
                      <span>Save</span>
                    </button>
                  )}
                  {/* <button
                        className="bg-blue-500 hover:bg-blue-700 text-white mt-3 ml-3 py-1 px-4 rounded"
                      >
                        Add
                      </button> */}
                  {type === "ADD" && (
                    <button
                    onClick={editHandler}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white ml-2 mt-3 py-1 px-4 rounded"
                    >
                    <LuView className="mt-1 mr-2 " />
                    <span>View</span>
                  </button>
                  )}
                  {/* {type === "ADD" && (
                    <button
                      onClick={editNozel}
                      className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                    >
                       <AiFillEdit className="mr-2 mt-1" />
                        
                        <span>Edit</span>
                    </button>
                  )}

                  {(type === "EDIT" || type === "DELETE") && (
                    <button
                      onClick={saveEditNozel}
                      className="bg-blue-500 hover:bg-blue-700 text-white ml-2 mt-3 py-1 px-4 rounded"
                    >
                      DONE
                    </button>
                  )}
                  {type === "ADD" && (
                    <button
                      onClick={confirmDelete}
                      className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                    >
                     <AiFillDelete className="mr-2 mt-1" />
                        
                        <span>Delete</span>
                    </button>
                  )} */}
                  {type !== "ADD" && (
                    <button
                      onClick={clearStates}
                      className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                    >
                      <BiExit className="mr-2 mt-1" />
                      <span>Exit</span>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </>)}
    </>
  );
};

export default Alert;
